import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { forwardRef, useEffect, useState } from 'react'
import { CustomPriceInput } from '../../../components/CustomPriceInput'

import './styles.css'
import { CustomButton } from '../../../components/CustomButton'
import {
  CheckCircleFill,
  DashCircleFill,
  PlusCircleFill,
} from 'react-bootstrap-icons'
import PessoasService from '../../../services/database/PessoasService'
import { toast } from 'react-toastify'

export const ModalModificarSaldo = forwardRef(
  ({ isOpen, pessoa, onClose, loadPessoas }, ref) => {
    const [operationType, setOperationType] = useState('entrada')
    const [isUpdateBalanceLoading, setIsUpdateBalanceLoading] = useState(false)
    const [value, setValue] = useState('')

    async function handleUpdateBalance() {
      try {
        setIsUpdateBalanceLoading(true)

        await PessoasService.updateBalance({
          codPessoa: pessoa.cod_pessoa,
          type: operationType,
          value,
        })

        toast.success('Saldo atualizado com sucesso!')
        onClose()

        loadPessoas()
      } catch (error) {
        console.log(`Erro ao atualizar saldo: ${error}`)
        toast.error('Erro ao atualizar saldo, tente novamente mais tarde!')
      } finally {
        setIsUpdateBalanceLoading(false)
      }
    }

    useEffect(() => {
      if (isOpen) {
        setOperationType('entrada')
        setIsUpdateBalanceLoading(false)
        setValue('')
      }
    }, [isOpen])

    return (
      <Modal
        ref={ref}
        show={isOpen}
        onHide={onClose}
        dialogClassName="modal-modificar-saldo-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: 20,
            }}
          >
            Modificar Saldo <strong>{pessoa.pes_razao}</strong>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <section className="operation-type">
            <div className="operation-type-section">
              <p>Tipo da operação</p>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                <OverlayTrigger overlay={<Tooltip>Adicionar Saldo</Tooltip>}>
                  <CustomButton
                    color="#008000"
                    onClick={() => setOperationType('entrada')}
                    styles={{
                      opacity: operationType === 'entrada' ? 1 : 0.4,
                    }}
                  >
                    <PlusCircleFill />
                  </CustomButton>
                </OverlayTrigger>

                <OverlayTrigger overlay={<Tooltip>Remover Saldo</Tooltip>}>
                  <CustomButton
                    color="#FF0000"
                    onClick={() => setOperationType('saida')}
                    styles={{
                      opacity: operationType === 'saida' ? 1 : 0.4,
                    }}
                  >
                    <DashCircleFill />
                  </CustomButton>
                </OverlayTrigger>
              </div>
            </div>

            <div className="operation-type-section">
              <p>Valor</p>

              <CustomPriceInput
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Digite o valor"
              />
            </div>
          </section>
        </Modal.Body>

        <Modal.Footer>
          <CustomButton
            isLoading={isUpdateBalanceLoading}
            onClick={handleUpdateBalance}
            title="Confirmar"
            color="#008000"
            isDisabled={!operationType || !value}
          >
            <CheckCircleFill />
          </CustomButton>
        </Modal.Footer>
      </Modal>
    )
  },
)
